/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import ActionsDropdown from '@/components/common/ActionsDropdown';
import DropdownItemButton from '@/components/common/ActionsDropdown/DropdownItemButton';
import useFlags from '@/hooks/useFlags';
import { ClassroomSchema } from '@/types/api/v2/ClassroomSchema';

const AUTO_ROSTER_PROVIDERS = ['clever', 'oneroster'];
const EXCLUDED_STAFFER_TOOLTIP = 'Programs cannot be modified for this classroom because a staffer is'
  + ' excluded from rostering';

type RowData = ClassroomSchema;

interface ClassesAdminDropdownProps {
  openModal: (e: React.MouseEvent, data: RowData, type: string) => void;
  rowData: RowData;
}

const ClassesAdminDropdown = ({ openModal, rowData }: ClassesAdminDropdownProps) => {
  const { manageProgramsClassesPage } = useFlags();
  const showManagePrograms = manageProgramsClassesPage && AUTO_ROSTER_PROVIDERS.includes(rowData.provider);

  return (
    <ActionsDropdown>
      <a
        className="dropdown-item"
        href="#"
        role="button"
        onClick={e => openModal(e, rowData, 'edit')}
      >
        <i aria-hidden="true" className="fa fa-edit" /> Edit Class Details
      </a>

      <a
        className="dropdown-item"
        href="#"
        role="button"
        onClick={e => openModal(e, rowData, 'students')}
      >
        <i aria-hidden="true" className="fa fa-user" /> Manage Students
      </a>

      <a
        className="dropdown-item"
        href="#"
        role="button"
        onClick={e => openModal(e, rowData, 'teachers')}
      >
        <i aria-hidden="true" className="fa fa-user" /> Manage Teachers
      </a>

      <a
        className="dropdown-item"
        href="#"
        role="button"
        onClick={e => openModal(e, rowData, 'delete')}
      >
        <i aria-hidden="true" className="fa fa-trash" /> Delete
      </a>

      {showManagePrograms && (
        <DropdownItemButton
          disabled={rowData.has_staffer_excluded_from_rostering}
          disabledTooltipText={EXCLUDED_STAFFER_TOOLTIP}
          icon="pencil-square-o"
          text="Manage Programs"
          onClick={(e: React.MouseEvent) => openModal(e, rowData, 'managePrograms')}
        />
      )}
    </ActionsDropdown>
  );
};

export default ClassesAdminDropdown;
